module.exports = __webpack_public_path__ + "static/media/2015.fee649a9.svg";